import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Group, GroupTransfer, LessonTransfer, NextLessonData} from "../../../../types/interfaces";
import {ModalController} from "@ionic/angular";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {PreloaderService} from "../../../../services/preloader/preloader.service";
import {GroupForTransfer, LessonForTransfer, LessonTransferResult} from "../../../../types/apiResponse.interface";

import {
    EXCLUDED_GROUP_TYPES_FOR_PRACTICING,
    GROUP_TYPE_ENG_TEACHER,
    GROUP_TYPE_URK_TEACHER,
    GROUP_TYPE_ZNO,
    TRANSFER_LESSON_SUCCESS, TRANSFER_LESSON_SUCCESS_PARENT, TRANSFER_NO_LESSONS
} from "../../../constants";
import {AuthService} from "../../../../services/mygreencountry/auth.service";

@Component({
    selector: 'app-transfer-lessons',
    templateUrl: './transfer-lessons.component.html',
    styleUrls: ['./transfer-lessons.component.scss'],
})
export class TransferLessonsComponent implements OnInit {

    @Input() groups: Group[] | undefined = undefined;
    @Input() toCancelLessonData: NextLessonData | undefined = undefined;
    @Input() open: boolean = false;

    @Output() openTransferModal: EventEmitter<string> = new EventEmitter();


    protected readonly GROUP_TYPE_URK_TEACHER: number = GROUP_TYPE_URK_TEACHER;
    protected readonly GROUP_TYPE_ENG_TEACHER: number = GROUP_TYPE_ENG_TEACHER;
    protected readonly GROUP_TYPE_ZNO: number = GROUP_TYPE_ZNO;
    protected readonly TRANSFER_NO_LESSONS: string = TRANSFER_NO_LESSONS;
    protected readonly TRANSFER_LESSON_SUCCESS: string = TRANSFER_LESSON_SUCCESS;
    protected readonly TRANSFER_LESSON_SUCCESS_PARENT: string = TRANSFER_LESSON_SUCCESS_PARENT;

    public groupsTransfer: GroupTransfer[] | undefined = undefined;
    public chosenGroup: GroupTransfer | undefined = undefined;
    public showTransferringContainer: boolean = false;
    public downloadingLessons: boolean = false;
    public downloadedLessons: boolean = false;
    public lessonHasTransferred: boolean = false;
    public cancelCreatedLesson: boolean = false;
    public cancelSucceeded: boolean | undefined = undefined;
    public fromLessonId: number | undefined = undefined;
    public toLessonId: number | undefined = undefined;
    public selectedGroupId: number | undefined = undefined;
    public isParent: boolean = false;
    public showNoGroupsDummy: boolean = false;
    public cancelLessonId: number | undefined = undefined;
    public cancelTransferId: number | undefined = undefined;
    public availableLessons: LessonTransfer[] | undefined = undefined;
    public transferredToLesson: LessonTransfer | undefined = undefined;

    constructor(private modalCtrl: ModalController,
                public myGcService: MyGreenCountry,
                private preloaderService: PreloaderService,
                private authService: AuthService,) {
    }

    ngOnInit() {
        this.isParent = this.authService.isParent() && this.authService.getLoginRole() === 'parent';

        if (this.toCancelLessonData) {
            this.cancelLessonId = this.toCancelLessonData.id;
            this.cancelTransferId = this.toCancelLessonData.transferId;

        } else if (this.groups) {
            this.groups = this.groups.filter(group =>
                !EXCLUDED_GROUP_TYPES_FOR_PRACTICING.has(group.typeCourse) && !group.isReserve
            );

            if (this.groups.length > 0) {
                this.downloadGroups();
            } else {
                this.showNoGroupsDummy = true;
            }
        }

    }

    close() {
        return this.modalCtrl.dismiss(null, 'cancel');
    }

    closeAndReload() {
        return this.modalCtrl.dismiss(null, 'reload');
    }

    async downloadGroups() {

        let groupIds = this.groups?.map(group => group.id)

        if (groupIds) {
            await this.preloaderService.showLoading("Зачекайте, будь ласка ");

            this.myGcService.getGroupsWithLessonsForTransfer(groupIds)
                .subscribe({
                    next: (response: GroupForTransfer) => {
                        if (response.groups.length > 0) {
                            this.groupsTransfer = response.groups;

                            if (this.groupsTransfer.length === 1) {
                                this.selectedGroupId = this.groupsTransfer[0].id;
                                this.chooseGroup()
                            }

                            this.showTransferringContainer = true;
                        }
                    },

                    error: (error) => {
                        console.log('error', error)

                    },

                    complete: () => {
                        this.preloaderService.hideLoading();
                    }

                })

        }
    }

    async getLessonsForTransfer() {

        if (this.fromLessonId && this.chosenGroup?.id) {
            this.availableLessons = undefined;
            await this.preloaderService.showLoading("Зачекайте, будь ласка ");

            this.myGcService.getLessonsForTransfer(this.chosenGroup.id, this.fromLessonId)
                .subscribe({
                    next: (response: LessonForTransfer) => {
                        if (response.success) {
                            this.availableLessons = response.lessonsTo.length > 0 ? response.lessonsTo : [];
                        } else {
                            this.availableLessons = [];
                        }

                        this.downloadedLessons = true;

                    },

                    error: (error) => {
                        console.log('error', error)

                    },

                    complete: () => {
                        this.preloaderService.hideLoading();
                    }

                })

        }


    }

    async createLessonTransfer() {

        if (this.fromLessonId && this.toLessonId && this.chosenGroup) {
            await this.preloaderService.showLoading("Зачекайте, будь ласка ");

            this.myGcService.createLessonTransfer(this.chosenGroup.id, this.fromLessonId, this.toLessonId)
                .subscribe({
                    next: (response: LessonTransferResult) => {

                        if (response.success) {
                            this.lessonHasTransferred = true;
                            this.transferredToLesson = response?.toLesson

                            this.cancelLessonId = this.transferredToLesson.id;
                            this.cancelTransferId = response.transferRecordId;

                        }

                    },

                    error: (error) => {
                        console.log('error', error)

                    },

                    complete: () => {
                        this.preloaderService.hideLoading();
                    }

                })

        }


    }


    chooseGroup() {
        this.chosenGroup = this.groupsTransfer?.find(group => group.id === Number(this.selectedGroupId));
        this.downloadedLessons = false;
    }

    // compareFn(e1: GroupTransfer, e2: GroupTransfer): boolean {
    //     return e1 && e2 ? e1.id === e2.id : e1 === e2;
    // }
    //
    // compareFn1 = (o1: any, o2: any): boolean => {
    //     return o1 === o2;
    // }

    compareFn(e1: any, e2: any): boolean {
        if (e1 && e2 && typeof e1 === 'object' && typeof e2 === 'object' && 'id' in e1 && 'id' in e2) {
            return e1 && e2 ? e1.id === e2.id : e1 === e2;
        }
        return e1 == e2;
    }

    chooseLessonFrom(event: Event) {
        if (this.fromLessonId) {
            this.downloadingLessons = true

            this.getLessonsForTransfer().then(r => this.downloadingLessons = false);
        }
    }

    getChooseLessonTitle() {
        let lesson = this.chosenGroup?.lessons?.find(group => group.id === Number(this.fromLessonId))

        if (lesson) {
            return lesson.date + ' - ' + lesson.title
        } else {
            return false;
        }

    }

    chooseLessonTo(event: Event) {
        let customEvent = event as CustomEvent;

        this.toLessonId = customEvent.detail?.value;
    }

    async cancelCreatedLessonTransfer() {

        this.cancelCreatedLesson = true;

    }

    async cancelLessonTransfer() {
        if (this.cancelLessonId && this.cancelTransferId) {
            await this.preloaderService.showLoading("Зачекайте, будь ласка ");

            this.myGcService.cancelLessonTransfer(this.cancelLessonId, this.cancelTransferId)
                .subscribe({
                    next: (response) => {
                        if (response.success) {
                            this.cancelSucceeded = true;
                        } else {
                            this.cancelSucceeded = false;
                        }

                    },

                    error: (error) => {
                        console.log('error', error)

                    },

                    complete: () => {
                        this.preloaderService.hideLoading();
                    }

                })

        }

    }
}
